import ApplicationComponent from "legacy/ApplicationComponent"
import FormGroup from "legacy/FormGroup"
import NextButton from "legacy/boater-reservation-flow/NextButton"
import { boatDisplayText, inchesToFeet } from "legacy/helpers.es6"
import { validatorFactory } from "legacy/validatorFactory"
import _ from "lodash"
import PropTypes from "prop-types"
import React from "react"

class InquiryBoatForm extends ApplicationComponent {
  constructor(props) {
    super(props)
    this.state = {
      boat: this.props.boat || this.blankBoat(),
    }
    this.validator = validatorFactory({ autoForceUpdate: this })
  }

  blankBoat() {
    return {
      boatType: "power",
    }
  }

  componentDidMount() {
    if (
      this.props.boats &&
      this.props.boats.length &&
      this.props.boats[0] &&
      (!this.props.boat || !this.props.boat.id)
    ) {
      this.handleBoatSelectChange(this.props.boats[0].id)
    }
  }

  handleBoatSelectChange(id) {
    const boat = _.find(this.props.boats, { id })
    if (boat) {
      this.setState({
        boat: {
          id: boat.id,
          name: boat.name,
          boatType: boat.boatType,
          lengthOverall: boat.lengthOverall / 12,
          beam: boat.beam / 12,
          height: boat.height / 12,
          draw: boat.draw / 12,
        },
      })
    } else {
      this.setState({ boat: this.blankBoat() })
    }
  }

  finish() {
    this.validator.showMessages()
    if (this.validator.allValid()) {
      this.props.handleBoat(this.state.boat)
    }
  }

  renderEditBoatForm() {
    if (!this.state.boat.id) {
      return (
        <div>
          <h3 className="text-lg">Boat</h3>
          <div className="row nested-row">
            <div className="col-sm-12">
              <FormGroup
                name="boat.name"
                label="Boat Name"
                value={this.state.boat.name}
                validation={this.validator.message(
                  "boat_name",
                  this.state.boat.name,
                  "required"
                )}
                onChange={this.handleInputChange}
              />
            </div>
          </div>
          <div className="row nested-row">
            <div className="col-sm-12">
              <FormGroup
                inputType="select"
                label="Boat Type"
                value={this.state.boat.boatType}
                name="boat.boatType"
                onChange={this.handleInputChange}
                validation={this.validator.message(
                  "boat_type",
                  this.state.boat.boatType,
                  "required"
                )}
              >
                <option value="power">Power Boat</option>
                <option value="sail">Sailboat</option>
              </FormGroup>
            </div>
          </div>
          <div className="row nested-row">
            <div className="col-xs-6">
              <div className="form-group">
                <label htmlFor="lengthOverall">Length Overall</label>
                <div className="form-control-with-icon">
                  <span className="form-control-icon-right">ft</span>
                  <input
                    type="text"
                    id="lengthOverall"
                    className="form-control"
                    name="boat.lengthOverall"
                    value={this.state.boat.lengthOverall}
                    onChange={this.handleInputChange}
                    data-content="Please round up to the nearest foot and include bowsprit, swim platform, davits, etc."
                    data-container="body"
                    data-trigger="focus"
                    data-toggle="popover"
                    data-placement="bottom"
                  />
                </div>
                {this.validator.message(
                  "length_overall",
                  this.state.boat.lengthOverall,
                  "required|numeric|min:1,num|max:2000,num"
                )}
              </div>
            </div>
            <div className="col-xs-6">
              <FormGroup
                inputType="feet"
                name="boat.beam"
                label="Beam"
                value={this.state.boat.beam}
                validation={this.validator.message(
                  "boat_beam",
                  this.state.boat.beam,
                  "required|numeric|min:1,num|max:1000,num"
                )}
                onChange={this.handleInputChange}
              />
            </div>
          </div>
        </div>
      )
    }
  }

  renderVerticalDimensionsForm() {
    if (this.props.heightConstraint || this.props.depthConstraint) {
      return (
        <div>
          <div className="col-xs-6">
            <FormGroup
              inputType="feet"
              name="boat.height"
              label="Height"
              value={
                this.state.boat.height ? parseInt(this.state.boat.height) : ""
              }
              validation={
                this.props.heightConstraint
                  ? this.validator.message(
                      "boat_height",
                      this.state.boat.height,
                      `required|maxHeight:${this.props.heightConstraint}`
                    )
                  : null
              }
              onChange={this.handleInputChange}
            />
          </div>
          <div className="col-xs-6">
            <FormGroup
              inputType="feet"
              name="boat.draw"
              label="Draft"
              value={this.state.boat.draw ? parseInt(this.state.boat.draw) : ""}
              validation={
                this.props.depthConstraint
                  ? this.validator.message(
                      "boat_draft",
                      this.state.boat.draw,
                      `required|maxDraft:${this.props.depthConstraint}`
                    )
                  : null
              }
              onChange={this.handleInputChange}
            />
          </div>
        </div>
      )
    }
  }

  renderBoatSelector() {
    if (this.props.boats && this.props.boats.length) {
      return (
        <div className="form-group">
          <label htmlFor="boat">Boat</label>
          <select
            className="form-control"
            id="boat"
            value={this.state.boat.id}
            onChange={(event) =>
              this.handleBoatSelectChange(Number(event.target.value))
            }
          >
            <option value={""}>(add new boat)</option>
            {_.map(this.props.boats, (boat) => (
              <option value={boat.id} key={boat.id}>
                {boatDisplayText(
                  boat.name,
                  inchesToFeet(boat.lengthOverall),
                  boat.make
                )}
              </option>
            ))}
          </select>
        </div>
      )
    }
  }

  render() {
    this.validator.purgeFields()
    return (
      <div>
        {this.renderBoatSelector()}
        {this.renderEditBoatForm()}
        <div className="row nested-row">
          {this.renderVerticalDimensionsForm()}
        </div>
        <NextButton
          click={this.finish.bind(this)}
          icon=""
          text="Continue"
          btnClass="btn btn-primary w-full"
        />
      </div>
    )
  }
}

InquiryBoatForm.propTypes = {
  boat: PropTypes.object,
  boats: PropTypes.array,
  handleBoat: PropTypes.func.isRequired,
  heightConstraint: PropTypes.number,
  depthConstraint: PropTypes.number,
}

export default InquiryBoatForm
